import { BulletedList, Header, SecondaryButton, Space } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'

interface INotConnectedViewProps {
  onConnect: () => void
}

export const NotConnectedView = ({ onConnect }: INotConnectedViewProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space direction='vertical' align='center' size='large'>
      <Header as='h4'>
        {intl.formatMessage(messages.notConnectedDescription)}
      </Header>
      <BulletedList>
        <BulletedList.Item>
          {intl.formatMessage(messages.notConnectedBulletApprovalStatus)}
        </BulletedList.Item>
        <BulletedList.Item>
          {intl.formatMessage(messages.notConnectedBulletPendingApproval)}
        </BulletedList.Item>
      </BulletedList>
      <SecondaryButton onClick={onConnect}>
        {intl.formatMessage(messages.addToSlackButton)}
      </SecondaryButton>
    </Space>
  )
}
